export default "__VITE_ASSET__DYTaUBn6__"